import { styled } from "@mui/system";
import Container from "@mui/material/Container";

export const StyledAgentFormNavigation = styled("ul")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  margin: 0,
  padding: 0,
  "& .agentFormNavigationLink": {
    padding: 0,
    margin: 0,
    "&:first-of-type": {
      "&:after": {
        content: "'I'",
        color: "var(--colour-text-primary,#000)",
        fontSize: "1rem",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "1.5rem",
        letterSpacing: "0rem",
        padding: "0.5rem"
      }
    },
    "& .stepLink": {
      color: "var(--colour-text-secondary, #4D4D4D)",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "1.5rem",
      letterSpacing: "0rem",
      "&.activeLink": {
        color: "var(--primary-500)",
        textDecorationLine: "underline"
      }
    }
  }
}));
export const StyledFormLayoutContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: "6rem",
  minHeight: "100%",

  "& .formWrapper": {
    width: "100%",
    paddingTop: "2rem",
    display: "flex",
    flexDirection: "column",
    "&.centeredContent": {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "center",

      [theme.breakpoints.up("sm")]: {
        height: "calc(100vh - (6.5rem + 6rem))",
        paddingTop: 0,
        paddingBottom: 0,
        alignItems: "center"
      }
    },
    "&.agentFormWrapper": {
      maxWidth: "54rem",
      [theme.breakpoints.up("sm")]: {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    "@media (min-width: 769px)": {
      paddingTop: "5rem",
      paddingBottom: "5rem",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  "& .contentWrapper": {
    width: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "relative",
    "&.showFormNavigation": {
      maxWidth: "54rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem 0"
    }
  },
  "& .chatButton": {
    width: "fit-content",
    position: "fixed",
    zIndex: 1,
    right: 0,
    bottom: 0,
    [theme.breakpoints.up("sm")]: {
      left: 20,
      bottom: "7rem"
    }
  },
  [theme.breakpoints.up("sm")]: {
    paddingBottom: "6.5rem"
  }
}));
